export interface timeFramesType {
  name: string;
  validValue: string;
}

export const timeFrames: timeFramesType[] = [
  { name: 'No timeframe specified', validValue: '0' },
  { name: 'Last day', validValue: '1' },
  { name: 'Last week', validValue: '2' },
  { name: 'Last 2 weeks', validValue: '3' },
  { name: 'Last month', validValue: '4' },
  { name: 'Last 3 months', validValue: '5' },
  { name: 'Last 6 months', validValue: '6' },
  { name: 'Last year', validValue: '7' },
];
